/**
 *  유저 상세 > 주문 정보 > 쿠폰 내역 리스트 필터 옵션 모델
 */
export const ACCOUNT_USER_DETAIL_COUPON_HISTORY_LIST_FILTER_OPTION_MODEL = {
  /**
   *  사용여부
   */
  isUsed: null,
  /**
   *  쿠폰 ID
   */
  couponId: null,
  /**
   *  쿠폰 발급 ID
   */
  couponGeneratedId: null,
  /**
   *  쿠폰명
   */
  name: null,
  /**
   *  쿠폰 설명
   */
  description: null,
  /**
   *  쿠폰 혜택
   */
  discountType: null,
  /**
   *  쿠폰 유형
   */
  availableType: null,
  /**
   *  입력 코드
   */
  code: null,
  /**
   *  발급일자
   */
  generateDate: {
    stateDate: null,
    endDate: null,
  },
  /**
   *  만료일자
   */
  endDate: {
    stateDate: null,
    endDate: null,
  },
  /**
   *  사용일자
   */
  useDate: {
    stateDate: null,
    endDate: null,
  },
  /**
   *  상품 주문번호
   */
  orderItemId: null,
};

export const COUPON_GENERATE_VALID_RESULT_MODEL = {
  requestCnt: null,
  possibleCnt: null,
  impossibleCnt: null,
  userCouponList: [],
};
